module.exports = DDC.WsmCommonData;


//////////////////
// WEBPACK FOOTER
// external "DDC.WsmCommonData"
// module id = 38
// module chunks = 0